export default __webpack_public_path__ + "static/screenSixthSectionRu-c02319048073bd78915f5eeb2cd1b51b.webp";